import React, { useEffect, useState } from 'react'
import { useProovedorData } from '../../../components';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import CallApi from '../../../data/CallApi';
import VideoHighWide from './VideoHighWide';
import { ImagenesGlobal } from '../../../components/global/ImagenesGlobal';
import PlayIcon from '../../../svg/PlayIcon';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

import CommentGlobe from '../../../svg/CommentGlobe';
import ShareIcon from '../../../svg/ShareIcon';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LimitText from '../../../components/global/LimitText';

const Main = () => {
  const { loadImageS, diferenciaFechas, userVideos, videoDataRef } = useProovedorData() ?? [];

  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const location = useLocation();
  const userKey = new URLSearchParams(location.search).get('authCode');

  const [videoObj, setVideoObj] = useState({
    wide: [],
    high: []
  });

  async function loadVideos() {
    const path = String(window.location.pathname).substring(0, 6);
    const itsGlobal = path == '/video' ? true : false;
    const uk = path != '/video' ? (userKey ?? 'me') : 'global';// user key    

    const existWide = userVideos?.[uk]?.wide ? true : false;
    const existHigh = userVideos?.[uk]?.high ? true : false;
    if (!userVideos?.[uk]) userVideos[uk] = {};

    let listWide;
    if (!existWide) {
      const fetchListWide = await CallApi({
        url: !itsGlobal ? `api/user/video?type=wide&user_key=${uk ?? 'me'}` : `api/global/videos?type=wide`
      });

      listWide = fetchListWide?.code ? [] : fetchListWide;
      userVideos[uk].wide = listWide;
    } else listWide = userVideos[uk].wide;

    let listHigh;
    if (!existHigh) {
      const fetchListHigh = await CallApi({
        url: !itsGlobal ? `api/user/video?type=high&user_key=${uk ?? 'me'}` : `api/global/videos?type=high`
      });

      listHigh = fetchListHigh?.code ? [] : fetchListHigh;
      userVideos[uk].high = listHigh;
    } else listHigh = userVideos[uk].high;

    setVideoObj({
      wide: listWide,
      high: listHigh,
    });
  }

  useEffect(() => {
    loadVideos();
  }, [userKey]);

  const replaceVideo = (file = null) => {
    if (!file) return null;

    return String(file).replace('video', 'preview').replace('mp4', 'webp');
  }

  const addParam = (key = null) => {
    if (!key) return;
    params.set("v", key);

    navigate(`${location.pathname}?${params.toString()}`);
  };

  return (
    <div>
      <div className='slider-videos'>
        <ul>
          {
            videoObj.high && videoObj.high.map((obj, index) => index < 5 && (
              <li>
                <LimitText lineLimit={[1, 2, 2]} class_container='text-video-limit-1'>
                  {obj?.description ?? 'Sin descripción...'}
                </LimitText>

                <div className={`lvu-high-img`}>
                  <ImagenesGlobal url={obj?.file_name ? ('media/' + replaceVideo(obj?.file_name)) : null} type='picture' loadImageS={loadImageS} />

                  <button className='default-buttons play-icon' onClick={() => addParam(obj?.video_key)}>
                    <PlayIcon />
                  </button>
                </div>

                <div className='lvu-interactions' style={{ position: 'relative' }}>
                  <span>
                    {
                      obj?.isLiked ?
                        (<FavoriteIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: 'var(--rojo)' }} />)
                        :
                        (<FavoriteBorderIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: 'var(--color-fonts-modal)' }} />)
                    }
                    {obj?.likes ?? 0}
                  </span>

                  <span>
                    <RemoveRedEyeIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: 'var(--color-fonts-modal)' }} />
                    {obj?.views ?? 0}
                  </span>

                  <span>
                    <CommentGlobe color={'var(--color-fonts-modal)'} main_css={{ width: 'clamp(18px, 2vw, 20px)', padding: '0px' }} />
                    {obj?.comments ?? 0}
                  </span>

                  <span>
                    <ShareIcon color={'var(--color-fonts-modal)'} main_css={{ width: 'clamp(18px, 2vw, 20px)', padding: '0px' }} />
                    {obj?.shared ?? 0}
                  </span>
                </div>
              </li>
            ))
          }
        </ul>

        <NavLink
          to={{ pathname: "/user/videos/long", search: location.search }}
          className={'default-buttons'}
          style={{ height: 'min-content' }}
        >
          Mostrar más
        </NavLink>
      </div>

      <br></br>

      {videoObj.wide && <VideoHighWide type='wide' />}
    </div>
  )
}

export default Main